import React from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { Linkedin, Github, FileText, File, Award, Landmark, ArrowRight } from 'lucide-react';
import { FaMedium } from 'react-icons/fa';

import './Landing.css';
import { theme } from '../../theme/designSystem';
import { headerData } from '../../data/headerData';
import { socialsData } from '../../data/socialsData';

import resumePdf from '../../assets/pdf/Ravi_Teja_Alchuri_Resume.pdf';
import cvPdf from '../../assets/pdf/Ravi_Teja_Alchuri_CV.pdf';

function Landing() {
    return (
        <section className='landing' id="home" style={{ backgroundColor: theme.secondary }}>
            <div className="landing--bg" aria-hidden="true" />

            <div className='landing--container'>
                <div className='landing--container-left'>
                    <div className='lcl--content fade-in-up'>
                        <span className='landing--role'>{headerData.role}</span>

                        <h1 style={{ color: theme.primary }}>
                            {headerData.firstName}{' '}
                            <span className="gradient-text">{headerData.lastName}</span>
                        </h1>

                        <p className='landing--tagline' style={{ color: theme.textPrimary }}>
                            {headerData.tagline}
                        </p>

                        <div className="landing--badges">
                            <a
                                href="https://ieee-collabratec.ieee.org/app/p/RaviTejaAlchuri"
                                target="_blank"
                                rel="noreferrer"
                                className="landing--badge landing--badge-gold"
                            >
                                <Award size={15} />
                                <span>IEEE Senior Member</span>
                            </a>
                            <span className="landing--badge">
                                <Landmark size={15} />
                                <span>Named on U.S. FMCSA Registry</span>
                            </span>
                        </div>

                        <p className='landing--desc' style={{ color: theme.textSecondary }}>
                            {headerData.description}
                        </p>

                        <div className='lcr-buttonContainer'>
                            <a href={resumePdf} target='_blank' rel='noreferrer' className="btn btn-primary">
                                <FileText size={18} />
                                View Résumé
                            </a>
                            <a href={cvPdf} target='_blank' rel='noreferrer' className="btn btn-secondary">
                                <File size={18} />
                                View CV
                            </a>
                            <NavLink to='/#contacts' smooth={true} className="btn btn-ghost">
                                Get in Touch <ArrowRight size={16} />
                            </NavLink>
                        </div>

                        <div className='landing--socials'>
                            {socialsData.linkedIn && (
                                <a href={socialsData.linkedIn} target='_blank' rel='noreferrer' aria-label="LinkedIn">
                                    <Linkedin className='landing--social' size={20} />
                                </a>
                            )}
                            {socialsData.github && (
                                <a href={socialsData.github} target='_blank' rel='noreferrer' aria-label="GitHub">
                                    <Github className='landing--social' size={20} />
                                </a>
                            )}
                            {socialsData.medium && (
                                <a href={socialsData.medium} target='_blank' rel='noreferrer' aria-label="Medium">
                                    <FaMedium className='landing--social' size={20} />
                                </a>
                            )}
                            <span className="landing--location">{headerData.location}</span>
                        </div>
                    </div>
                </div>

                <div className='landing--container-right fade-in-up delay-2'>
                    <div className='landing--portrait'>
                        <div className='landing--portrait-ring' aria-hidden="true" />
                        <img
                            src={headerData.image}
                            alt={`${headerData.name}, ${headerData.role}`}
                            className='landing--dp'
                        />
                        <div className="landing--stats">
                            <div className="landing--chip landing--chip-top">
                                <strong>100K+</strong>
                                <span>vehicles served</span>
                            </div>
                            <div className="landing--chip landing--chip-bottom">
                                <strong>10+ yrs</strong>
                                <span>building production systems</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Landing;
